import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {
  ApiDeviceGroupActionResponseDto,
  ApiDeviceGroupListResponseDto,
  ApiDeviceGroupRequestDto,
  ApiDeviceGroupResponseDto
} from '@birco/rainmesh-api';
import { DeviceGroupFilter } from '../../../features/devices/state/device-groups/device-group.state';

export interface DeviceGroupService {

  getDeviceGroups(options: DeviceGroupFilter): Observable<ApiDeviceGroupListResponseDto>;

  triggerDeviceGroupAction(options: { id: string, value: boolean }): Observable<ApiDeviceGroupActionResponseDto>;

  getDeviceGroupById(options: { id: string }): Observable<ApiDeviceGroupResponseDto>;

  createDeviceGroup(options: ApiDeviceGroupRequestDto): Observable<ApiDeviceGroupResponseDto>;

  updateDeviceGroup(options: { id: string; requestDto: ApiDeviceGroupRequestDto }): Observable<ApiDeviceGroupResponseDto>;

  deleteDeviceGroup(options: { id: string }): Observable<void>;
}

export const DEVICE_GROUP_STATE_SERVICE_INJECTION_TOKEN = new InjectionToken<DeviceGroupService>('DeviceGroupService');
